<div class="main-container-wrapper">
    <div class="main-container">
        <div class="title-container">
            <h1 class="title">Liste des contrats</h1>
            <div class="year-picker-and-button-container">
                <!-- year -->
                <div class="tv-year-picker-round-extensible-no-label-no-border width-180px">
                    <mat-form-field class="tv-date-range-picker">
                        <input matInput [matDatepicker]="dp" placeholder="YYYY" [formControl]="yearFormControl" name="year" />
                        <mat-datepicker-toggle matPrefix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp startView="multi-year" (yearSelected)="handleYearDatepickerValueChange($event, dp)">
                        </mat-datepicker>
                    </mat-form-field>
                </div>
                <button class="tv-ns-primary-large-button-on-light-bg" (click)="onContractCreateButtonClick()">Créer un contrat</button>
            </div>
        </div>

        <div class="light-flex-card">
            <!-- filters -->
            <div class="filters-and-table-container">
                <div class="table-search-export-container">
                    <!-- search -->
                    <div class="tv-round-input-extensible-no-label width-300px">
                        <mat-form-field>
                            <mat-label>Chercher</mat-label>
                            <mat-icon matPrefix>search</mat-icon>
                            <input matInput [formControl]="searchFormControl" name="search" />
                        </mat-form-field>
                    </div>

                    <!-- choose column -->
                    <app-filter-popup [onFilterItemClick]="applyFilterToTable" [filterItems]="allDisplayedColumns"></app-filter-popup>
                </div>

                <!-- table -->
                <div class="div-table-container">
                    <table
                        *ngIf="!isLoadingItems; else loading"
                        mat-table
                        [dataSource]="items"
                        class="tv-ns-mat-table table"
                        matSort
                        (matSortChange)="sortData($event)"
                        matSortActive="name"
                        matSortDisableClear
                        matSortDirection="asc">
                        <ng-container matColumnDef="id">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                class="header-cell-center-align font-ns"
                                mat-sort-header="id"
                                sortActionDescription="Sort by name">
                                Numéro Client
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.id }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="name">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                class="header-cell-center-align font-ns"
                                mat-sort-header="name"
                                sortActionDescription="Sort by name">
                                Nom Client
                            </th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.name }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="centralAgency">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">Agence</th>
                            <td
                                mat-cell
                                *matCellDef="let item"
                                class="icon-cell"
                                [ngClass]="{
                                    'agency-active': item.centralAgency?.temActif === 'Y',
                                    'agency-inactive': item.centralAgency?.temActif === 'N'
                                }"
                                (click)="onIconClick(item)">
                                {{ item.centralAgency.name }} ({{ item.centralAgency.id }})
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="contractManager">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">Commercial</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.contractManager.name }} ({{ item.contractManager.id }})
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cgvLabel">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">Libelle CGV Contrat</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.cgvLabel }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="stateContractLabel">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">Etat du contrat</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.stateContractLabel }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.CA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['cgvReturnDate']" matColumnDef="cgvReturnDate">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">Date Retour</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.cgvReturnDate }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['cgvStateNum']" matColumnDef="cgvStateNum">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">Etat</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.cgvStateNum }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['cgvStatus']" matColumnDef="cgvStatus">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">Statut</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.cgvStatus }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['f2f3f5CA']" matColumnDef="f2f3f5CA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA F2/F3/F5</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.f2f3f5CA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['regionCA']" matColumnDef="regionCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA Régional</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.regionCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['thematicCA']" matColumnDef="thematicCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA Thématique</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.thematicCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['sponsorshipFtpCA']" matColumnDef="sponsorshipFtpCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA Parrainage FTP</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipFtpCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['sponsorshipThematicCA']" matColumnDef="sponsorshipThematicCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA Parrainage Thématique</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipThematicCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['sponsorshipRegCA']" matColumnDef="sponsorshipRegCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA Parrainage Reg</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipRegCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['sponsorshipSoReachCA']" matColumnDef="sponsorshipSoReachCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA Parrainage SOReach</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipSoReachCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['sponsorshipWebCA']" matColumnDef="sponsorshipWebCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA Parrainage Web</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.sponsorshipWebCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['webCA']" matColumnDef="webCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA Web</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.webCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['OIWebCA']" matColumnDef="OIWebCA">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">CA OI Web</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                {{ item.OIWebCA?.toLocaleString('fr-FR') }}
                            </td>
                        </ng-container>

                        <ng-container *ngIf="allDisplayedColumns['open']" matColumnDef="open" (click)="onIconClick($event)">
                            <th mat-header-cell *matHeaderCellDef class="header-cell-center-align font-ns">Visualiser</th>
                            <td mat-cell *matCellDef="let item" class="icon-cell" (click)="onIconClick(item)">
                                <mat-icon (click)="onIconClick(item)">remove_red_eye</mat-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </div>

                <ng-template #loading>
                    <div class="spinner-container min-height-50">
                        <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
